import { BaseStore } from 'src/store';

export const getRetailers = (state: BaseStore) => {
  const { visibleRetailers, retailers } = state.retail;
  return visibleRetailers ? visibleRetailers : retailers;
};

export const getVisibilityFilters = (state: BaseStore) => {
  const { filters } = state.retail;
  return { filters };
};

export const getMap = (state: BaseStore) => {
  return { map: state.retail.map };
};

export const getVisibleRetailers = (state: BaseStore) => {
  const visibleRetailers = getRetailers(state);
  const { currentLocation } = state.retail;
  let outputState = { retailers: visibleRetailers, currentLocation: null };
  if (currentLocation) {
    outputState = { ...outputState, currentLocation };
  }
  return outputState;
};
